import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdKeyboardArrowRight } from 'react-icons/md';

const OrderProgress = ({ isInProgress, isCompleted, orderNumber, onClick }) => {
  const { t } = useTranslation();

  const renderFullPill = () => {
    return <div className="rounded-lg bg-success2 flex-1 h-2" />;
  };

  const renderEmptyPill = () => {
    return <div className="rounded-lg bg-input flex-1 h-2" />;
  };

  const renderProgressBar = () => {
    return (
      <div className="flex flex-row w-full">
        {renderFullPill()}
        <div className="w-[2px]" />
        {isCompleted || isInProgress ? renderFullPill() : renderEmptyPill()}
        <div className="w-[2px]" />
        {isCompleted ? renderFullPill() : renderEmptyPill()}
      </div>
    );
  };

  const getStatusText = () => {
    if (isCompleted) {
      return t('order.completedStatus');
    }

    if (isInProgress) {
      return t('order.inProgressStatus');
    }

    return t('order.receivedStatus');
  };

  if (onClick) {
    return (
      <div role="button" className="rounded-3xl border border-border py-4 px-3" onClick={onClick}>
        <div className="flex flex-row items-end flex-wrap justify-between">
          <div className="flex flex-row items-end flex-wrap mr-5 mb-2">
            <p className="font-primaryMedium text-2xl text-primary whitespace-nowrap mr-5">
              {t('header.order')} {orderNumber}
            </p>
            <p className="font-primaryMedium text-primary text-base">{getStatusText()}</p>
          </div>
          <div className="flex flex-row items-center justify-end mb-2">
            <p className="font-primaryMedium text-bland text-sm">{t('buttons.seeOrder')}</p>
            <div className="top-[1px] relative">
              <MdKeyboardArrowRight size={18} className="text-bland" />
            </div>
          </div>
        </div>
        <div className="mt-2">{renderProgressBar()}</div>
      </div>
    );
  }

  return (
    <div>
      <p className="font-primaryMedium text-primary text-base mb-4">{getStatusText()}</p>
      {renderProgressBar()}
    </div>
  );
};

export default OrderProgress;
